import React from 'react';
import { useField } from 'formik';

import { FormikField } from 'types';
import { IconButton } from 'common/buttons';

import { InputProps, TextAreaProps } from './types';
import {
  Container,
  StyledInput,
  StyledTextArea,
  EyeBtnContainer,
} from './styles';

export const Input = ({
  type,
  label,
  error,
  disabled,
  containerStyle,
  ...props
}: InputProps) => {
  const [isSecure, setIsSecure] = React.useState(type === 'password');

  const inputType = React.useMemo(() => {
    if (type === 'password') return isSecure ? type : 'text';
    return type;
  }, [type, isSecure]);

  return (
    <Container error={error} style={{ ...containerStyle }}>
      {label && <p>{label}</p>}
      <div style={{ position: 'relative' }}>
        <StyledInput
          error={error}
          type={inputType}
          disabled={disabled}
          {...props}
        />

        {type === 'password' && (
          <EyeBtnContainer>
            <IconButton
              disabled={disabled}
              onClick={() => setIsSecure(!isSecure)}
              icon={isSecure ? 'eye-closed' : 'eye-open'}
            />
          </EyeBtnContainer>
        )}
      </div>
    </Container>
  );
};

export const TextArea = ({
  label,
  error,
  containerStyle,
  mininputheight,
  ...props
}: TextAreaProps) => {
  return (
    <Container error={error} style={{ ...containerStyle }}>
      {label && <p>{label}</p>}
      <StyledTextArea
        error={error}
        mininputheight={mininputheight}
        {...props}
      />
    </Container>
  );
};

export const InputField = ({ name, ...props }: FormikField<InputProps>) => {
  const [field, meta, helpers] = useField(name);

  return (
    <Input
      name={name}
      error={meta.error}
      value={field.value || ''}
      onChange={(event) => helpers.setValue(event.target.value)}
      {...props}
    />
  );
};

export const TextAreaField = ({
  name,
  ...props
}: FormikField<TextAreaProps>) => {
  const [field, meta, helpers] = useField(name);

  return (
    <TextArea
      name={name}
      error={meta.error}
      value={field.value || ''}
      onChange={(event) => helpers.setValue(event.target.value)}
      {...props}
    />
  );
};
